const ALLOWED_RETURN_ORIGINS = new Set(['https://kvadrat.swipa.ru', 'https://recipe.swipa.ru']);

export function getSafeReturnTo(search: string): string | null {
  const raw = new URLSearchParams(search).get('returnTo');
  if (!raw) return null;
  try {
    const url = new URL(raw);
    return ALLOWED_RETURN_ORIGINS.has(url.origin) ? url.toString() : null;
  } catch {
    return null;
  }
}

export function withReturnTo(path: string, returnTo: string | null): string {
  return returnTo ? `${path}?returnTo=${encodeURIComponent(returnTo)}` : path;
}
